import Header6 from './Header6.js'
export default Header6
